// neurotrader-admin/src/components/AdminProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminProtectedRoute = ({ children }) => {
    const { isAuthenticated, isAdmin, loading } = useAuth();

    if (loading) return <div>Carregando...</div>;

    if (isAuthenticated && isAdmin) {
        return children; // Se logado E admin, permite o acesso
    }

    if (isAuthenticated && !isAdmin) {
        // O ideal seria ter uma página de erro 403. Por enquanto, login funciona.
        return <Navigate to="/login" />;
    }

    // Se não está autenticado, manda para a página de login.
    return <Navigate to="/login" />;
};

export default AdminProtectedRoute;